import { render, staticRenderFns } from "./centerLeft2.vue?vue&type=template&id=12ede813&scoped=true&"
import script from "./centerLeft2.vue?vue&type=script&lang=js&"
export * from "./centerLeft2.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft2.vue?vue&type=style&index=0&id=12ede813&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ede813",
  null
  
)

export default component.exports